import axios from '@/core/axios';

import { AccountingImportResponse } from './accounting-imports.types';

export class AccountingImportsService {
  preview(
    file: File,
    marketplaceId: number,
    previousBalance: number | null = null,
    exchangeRate: number | null = null,
    paymentDate: string | null = null
  ): Promise<AccountingImportResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('marketplace_id', String(marketplaceId));
    if (previousBalance !== null) formData.append('previous_balance', String(previousBalance));
    if (exchangeRate !== null) formData.append('exchange_rate', String(exchangeRate));
    if (paymentDate !== null) formData.append('payment_date', paymentDate);
    return axios.post<AccountingImportResponse>('/accounting/imports/preview', formData).then(resp => resp?.data);
  }

  downloadCSV(
    file: File,
    marketplaceId: number,
    previousBalance: number | null = null,
    exchangeRate: number | null = null,
    paymentDate: string | null = null,
    forceReimport = false
  ): Promise<{ blob: Blob; filename: string | null }> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('marketplace_id', String(marketplaceId));
    if (previousBalance !== null) formData.append('previous_balance', String(previousBalance));
    if (exchangeRate !== null) formData.append('exchange_rate', String(exchangeRate));
    if (paymentDate !== null) formData.append('payment_date', paymentDate);
    if (forceReimport) formData.append('force_reimport', 'true');
    return axios
      .post('/accounting/imports/csv', formData, { responseType: 'blob' })
      .then(resp => ({ blob: resp?.data, filename: parseFilename(resp?.headers?.['content-disposition']) }));
  }
}

/* Extrait le nom de fichier du header Content-Disposition (priorité à filename* UTF-8,
 * qui gère les caractères accentués, sinon retombe sur filename=) */
function parseFilename(contentDisposition: string | undefined): string | null {
  if (!contentDisposition) return null;
  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) return decodeURIComponent(utf8Match[1]);
  const plainMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  return plainMatch ? plainMatch[1] : null;
}

export const accountingImportsService = new AccountingImportsService();
